var InGo = window.InGo = window.InGo || {};

var KEY = 'InGo.debug'

if(window.sessionStorage) {
  var value = sessionStorage.getItem(KEY);
  InGo._debug = value === 'true';
}

/**
 * Enable/disable debug
 * @param  {boolean} value
 */
InGo.setDebug = function(value) {
  InGo._debug = value;
  if(window.sessionStorage) {
    sessionStorage.setItem(KEY, String(value));
  }
};

function debug() {
  if(InGo._debug && typeof console !== 'undefined') {
    if(navigator.userAgent.match(/MSIE ([0-9]{1,}[\.0-9]{0,})/)) {
      var args = [];
      for (var i = 0; i < arguments.length; i++)
        args.push(JSON.stringify(arguments[i]));
      console['l' + 'og'](args);
    } else {
      console['l' + 'og'].apply(console, arguments);
    }
  }
}

module.exports = debug;
